// removed by extract-text-webpack-plugin
module.exports = {"logo-wrapper":"_3NSqv","tick":"_3LdXR","small-tick":"_12wYI","opacity":"_2zekA","charity-info":"bEXTP","jg-tooltip-desktop":"_298tt","jg-tooltip-mobile":"q8B10","tooltip-modal-button":"_13PEL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CharityEndorsed/CharityEndorsed.scss
// module id = ./src/components/CharityEndorsed/CharityEndorsed.scss
// module chunks = 4